import { Component } from 'react';
import debounce from '../../lib/debounce';

class AdditionalBox extends Component {
    constructor(props) {
        super();

        this.onChange = this.onChange.bind(this);

        this.state = {
            value: props.staticAverageCTR ?? 0,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.staticAverageCTR !== prevProps.staticAverageCTR) {
            this.setState({
                value: this.props.staticAverageCTR ?? 0,
            });
        }
    }

    debounceLog = debounce((value) => {
        this.props.changeAverageCTR(value);
    }, 1000);

    onChange(e) {
        this.setState({
            value: e.target.value,
        });
        this.debounceLog(e.target.value);
    }

    render() {
        const { t } = this.props;
        return (
            <div className="table-additional-view live-report-ctr-change-box">
                <div className="table-additional-view-btns">
                    <div className="d-flex gap-8">
                        <div className="switch-container">
                            <button
                                className={`switch-button without-text ${
                                    this.props.isShowLowCTR ? 'active' : 'not-active'
                                }`}
                                onClick={() => this.props.showLowCTR()}
                                disabled={this.props.getCtrLoader}
                            >
                                <span className="switch-circle"></span>
                            </button>
                        </div>
                        <div>{t('discover.live_optimization.table.low_ctr')}</div>
                    </div>
                </div>
                <div className="d-flex gap-8 align-items-center live-report-ctr-change-box-input">
                    <input
                        className="form-commerce-input"
                        name="ctr_value"
                        value={this.state.value}
                        onChange={this.onChange}
                        disabled={this.props.getCtrLoader}
                        type="number"
                    />
                    <div className="percent">%</div>
                </div>
            </div>
        );
    }
}

export default AdditionalBox;
